import { v4 as uuidv4 } from 'uuid';

import { ProductsSequenceProduct } from 'common/contracts';

import { ProductEntry } from './usePopupProducts';

export const MAX_PRODUCTS_PER_SEQUENCE = 20;

export const appendProduct = (
  list: ProductEntry[],
  product: ProductsSequenceProduct,
): ProductEntry[] => {
  if (list.length >= MAX_PRODUCTS_PER_SEQUENCE) return list;
  return [...list, { ...product, id: uuidv4() }];
};

export const replaceWithSingleProduct = (
  product: ProductsSequenceProduct,
): ProductEntry[] => [{ ...product, id: uuidv4() }];
